import React from "react";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useFormikContext } from "formik";

const PREFIX = "StandardCachePageReview";

const classes = {
  listItem: `${PREFIX}-listItem`,
  total: `${PREFIX}-total`,
  title: `${PREFIX}-title`,
  smallFont: `${PREFIX}-smallFont`,
  rightItem: `${PREFIX}-rightItem`,
  marginTop: `${PREFIX}-marginTop`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled("div")(({ theme }) => ({
  [`& .${classes.listItem}`]: {
    padding: theme.spacing(0, 1, 1, 3),
    display: "flex",
    flexDirection: "row",
  },

  [`& .${classes.total}`]: {
    fontWeight: 700,
  },

  [`& .${classes.title}`]: {
    marginTop: theme.spacing(2),
  },

  [`& .${classes.smallFont}`]: {
    fontSize: "0.93rem",
  },

  [`& .${classes.rightItem}`]: {
    width: "50%",
    padding: theme.spacing(2),
    overflowWrap: "break-word",
  },

  [`& .${classes.marginTop}`]: {
    marginTop: theme.spacing(4),
  },
}));

export default function StandardCachePageReview(props) {
  const { values } = useFormikContext();

  return (
    <Root>
      <List>
        {values.cachepage_stim_list.map((cache_page, index) => (
          <React.Fragment key={index}>
            <ListItem className={classes.listItem}>
              <ListItemText
                primary="Page URL"
                secondary={`Additional page ${index + 1}`}
              />
              <Typography
                align="right"
                className={classes.rightItem}
                variant="body2"
                component={"span"}
              >
                {cache_page.cachepage_url.toString().substring(0, 60)}...
              </Typography>
            </ListItem>
            {cache_page.stim_list.map((stim, index) => {
              if (stim.brand_id && stim.stim_url) {
                return (
                  <ListItem className={classes.listItem} key={index}>
                    <ListItemText
                      classes={{ primary: classes.smallFont }}
                      inset
                      primary={`${stim.brand_id.name} ad URL ${index + 1}`}
                      secondary={`${stim.ad_type_id.description}`}
                    />
                    <Typography
                      className={classes.rightItem}
                      align="right"
                      variant="body2"
                      component={"span"}
                    >
                      {stim.stim_url.toString().substring(0, 40)}...
                    </Typography>
                  </ListItem>
                );
              } else {
                return <React.Fragment key={index}></React.Fragment>;
              }
            })}
          </React.Fragment>
        ))}
      </List>
    </Root>
  );
}
